import React from "react"

const FilterHierarchicalIcon = ({ isFromWidgetChoice }) => (
  <i
    className="fa-solid fa-sitemap"
    style={{ fontSize: isFromWidgetChoice ? "1rem" : "0.85rem" }}
  />
)

export default FilterHierarchicalIcon
